import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import CustomImageNodeView from '../components/ui/CustomImageNodeView';

export interface CustomImageOptions {
  HTMLAttributes: Record<string, unknown>;
  getCurrentUrl?: (imageId: string) => string | undefined;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    customImage: {
      setCustomImage: (options: {
        src: string;
        alt?: string;
        title?: string;
        width?: number;
        height?: number;
        'data-image-id'?: string;
      }) => ReturnType;
    };
  }
}

export const CustomImageExtension = Node.create<CustomImageOptions>({
  name: 'customImage',

  inline: true,
  group: 'inline',
  draggable: true,
  selectable: true,
  atom: true,

  addOptions() {
    return {
      HTMLAttributes: {},
      getCurrentUrl: undefined,
    };
  },

  addAttributes() {
    return {
      src: {
        default: null,
      },
      alt: {
        default: null,
      },
      title: {
        default: null,
      },
      width: {
        default: 300,
      },
      height: {
        default: 200,
      },
      isAvatar: {
        default: false,
      },
      'data-image-id': {
        default: null,
      },
      'data-fallback-initials': {
        default: null,
      },
      'data-is-cropped': {
        default: null,
      },
      'data-cropped-data': {
        default: null,
      },
      'data-is-annotated': {
        default: null,
      },
      'data-annotated-data': {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'img[src]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['img', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(CustomImageNodeView);
  },

  addCommands() {
    return {
      setCustomImage:
        (options) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: options,
          });
        },
    };
  },
});
